<script setup>
// Desktop-nav "More" dropdown — groups secondary top-level links (Invest,
// Murals, List your business) so the primary catalog links stay uncrowded.
// Text trigger styled to match .public-nav__link; the mobile hamburger menu
// keeps listing every item flat, so this is a desktop-only declutter.
import { ref, onMounted, onBeforeUnmount } from 'vue'

defineProps({
  label: { type: String, required: true }
})

const open = ref(false)
const root = ref(null)

function toggle() { open.value = !open.value }
function close()  { open.value = false }

function onDocClick(e) {
  if (root.value && !root.value.contains(e.target)) close()
}
function onKey(e) {
  if (e.key === 'Escape') close()
}

onMounted(() => {
  document.addEventListener('click', onDocClick)
  document.addEventListener('keydown', onKey)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', onDocClick)
  document.removeEventListener('keydown', onKey)
})
</script>

<template>
  <div ref="root" class="nav-more">
    <button
      type="button"
      class="nav-more__btn"
      :aria-haspopup="true"
      :aria-expanded="open"
      @click="toggle"
    >
      {{ label }}
      <svg class="nav-more__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </button>
    <div v-if="open" class="nav-more__panel" role="menu">
      <slot :close="close" />
    </div>
  </div>
</template>

<style scoped>
.nav-more { position: relative; display: inline-flex; }
.nav-more__btn {
  display: inline-flex; align-items: center; gap: 0.2rem;
  background: transparent; border: 0; padding: 0; cursor: pointer;
  color: var(--inkSoft); font: inherit; font-weight: 500;
}
.nav-more__btn:hover { color: var(--ink); }
.nav-more__caret { width: 0.85rem; height: 0.85rem; }
.nav-more__panel {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  min-width: 12rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 0.625rem;
  padding: 0.375rem;
  box-shadow: 0 8px 24px color-mix(in oklch, var(--ink) 14%, transparent);
  z-index: 50;
  display: flex;
  flex-direction: column;
}
.nav-more__panel :deep(a) {
  display: block;
  padding: 0.55rem 0.75rem;
  border-radius: 0.4rem;
  color: var(--ink);
  text-decoration: none;
  font-size: 0.9375rem;
  white-space: nowrap;
}
.nav-more__panel :deep(a:hover) { background: color-mix(in oklch, var(--ink) 6%, transparent); }
</style>
